// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"inputWrapper-YC0KoJ","input":"input-m_aWUq","searchIcon":"searchIcon-ZJTPnq"};